import { SubmitGame as DLSubmitGame, ValidatePlayer as DLValidatePlayer, ShowOverlay as DLShowOverlay, HideOverlay as DLHideOverlay, RefreshOverlay as DLRefreshOverlay, ConfigOverlay as DLConfigOverlay, ConfigGame as DLConfigGame, ResetGame as DLResetGame } from './../../../DL/Admin/Games/PluckingRooster'


const SubmitGame = async (userData, score) => {
    try {
        // 1. Preparamos el Payload (DTO)
        const payload = {
            fullName: userData.fullName,
            phoneNumber: userData.phoneNumber,
            email: userData.email,
            companionType: userData.companionType,
            score: score
        };

        // 2. Llamamos a la capa de datos
        const response = await DLSubmitGame(payload);

        // 3. Interpretamos la respuesta para la Vista
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            // Lógica de mensajes de error
            let userMessage = '¡Ups! Ha habido un error con tu conexión de internet o datos móviles';
            
            if (response.status === 409) {
                userMessage = '¡Gracias por tu participación! Ya has jugado anteriormente'; // con este correo/teléfono
            } else if (response.message) {
                userMessage = response.message;
            }

            return { success: false, message: userMessage };
        }
    }
    catch (e) {
        return { success: false, message: 'No ha sido posible enviar tu puntuación. Inténtalo de nuevo.' };
    }
}

const ValidatePlayer = async (email, phone) => {
    try {
        const response = await DLValidatePlayer(email, phone);
        
        if (response.success) {
            return { success: true };
        } else {
            let msg = 'Error al validar tus datos.';

            if (response.status === 409) msg = '¡Gracias por tu participación! Ya has jugado anteriormente'; // Ya has participado con este correo o teléfono.
            
            return { success: false, message: msg };
        }
    } catch (error) {
        return { success: false, message: 'No ha sido posible validar tus datos. Inténtalo nuevamente o inténtalo más tarde' }
    }
};

const ShowOverlay = async () => {
    return await DLShowOverlay()
}

const HideOverlay = async () => {
    return await DLHideOverlay()
}

const RefreshOverlay = async () => {
    return await DLRefreshOverlay()
}

const ConfigOverlay = async (layoutMode, offset) => {
    return await DLConfigOverlay({ layoutMode: layoutMode, positionOffset: offset })
}

const ConfigGame = async (duration) => {
    if(duration < 5) return { success: false, message: 'La duración mínima es 5 segundos' }
    return await DLConfigGame({ durationSeconds: duration })
}

const ResetGame = async () => {
    return await DLResetGame()
}

export { SubmitGame, ValidatePlayer, ShowOverlay, HideOverlay, RefreshOverlay, ConfigOverlay, ConfigGame, ResetGame };










// const SubmitGame = async () => {
//     try {
//         const response = await DLSubmitGame()

//         if (response.success) {
//             return { success: true, data: response.data };
//         } else {
//             return { success: false, message: response.message };
//         }
//     }
//     catch
//     {
//         return { success: false, message: 'No ha sido posible enviar tu puntuación. Actualiza la página' };
//     }
// }

// export { SubmitGame };